import ChangeBg from "../../../assets/images/ChangeBg.svg";
import Tours from "../../verification/sections/Tours";
import ResponsiveTours from "../../verification/sections/ResponsiveTours";
// import personalBg from "../../../assets/images/personal-bg.svg";
import Close from "../../../assets/images/X.svg";
import Button from "../../../components/Button";
import { useTransformedData } from "../../../contexts/TransformedDataContext";
import { useDispatch, useSelector } from "react-redux";
import { useSelectedTours } from "../../../contexts/SelectedToursContext";
import { useEffect, useState } from "react";
import { updateAttendanceThunk } from "../../../lib/service/attendance/updateAttendanceSlice";
import { fetchToursDatesThunk } from "../../../lib/service/tours/toursAvailableDatesSlice";
import { fetchCategoriesThunk } from "../../../lib/service/categories/categoriesSlice";
import { fetchToursDetailsThunk } from "../../../lib/service/tours/toursDetailsSlice";
import Cookies from "js-cookie";
import { fetchToursThunk } from "../../../lib/service/tours/toursSlice";
import Spinner from "../../../components/Spinner";
import toast from "react-hot-toast";
import { debounce } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
function EditBooking({
  onClick,
  itemId,
  title,
  tourType,
  date,
  attendanceId,
  bookingsByDate,
  categoryIdsArray,
  tourIdsArray,
}) {
  const [attendanceData, setAttendanceData] = useState(null);
  const { transformedData, setTransformedData } = useTransformedData();
  const [isLoadingState, setIsLoadingState] = useState(true);
  const [localBookingsByDate, setLocalBookingsByDate] = useState(bookingsByDate);
  const location = useLocation();
  const currentDate = location?.state?.date;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const safeBookingsByDate = bookingsByDate || {};
  const { loggedIn, logout } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (!bookings?.data?.bookings_by_date || !selectedTours) {
      navigate("/verification");
    }
  }, [navigate]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.returnValue = "Are you sure you want to leave?";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (bookingsByDate) {
      setLocalBookingsByDate(bookingsByDate);
    }
  }, [bookingsByDate]);
  const {
    data: UpdateAttendanceData,
    loading: UpdateAttendanceLoading,
    error: UpdateAttendanceError,
  } = useSelector((state) => state.updateAttendance);

  const { tours, loading, error } = useSelector((state) => state.tours);

  const {
    details,
    loading: detailsLoading,
    error: detailsError,
  } = useSelector((state) => state.toursDetails);
  const {
    bookings,
    loading: bookingsLoading,
    error: bookingsError,
  } = useSelector((state) => state.bookings);

  const {
    categories,
    loading: categoriesLoading,
    error: categoriesError,
  } = useSelector((state) => state.categories);
  const [selectedTours, setSelectedTours] = useState([]);

  useEffect(() => {
    if (!localBookingsByDate || Object.keys(localBookingsByDate).length === 0) {
      console.warn("localBookingsByDate is empty or undefined");
      return;
    }

    // Get the entries safely
    const dates = Object.entries(localBookingsByDate);

    // Use find and handle cases where no match is found
    const foundDate = dates?.find(([key]) => key === date);

    // If no matching date is found, log a warning and return early

    if (!foundDate) {
      console.warn(`No bookings found for date: ${date}`);
      return;
    }

    const [datee, books] = foundDate; // Safe destructuring

    // Flatten and map the items
    const allItems = books?.flatMap((b) => b?.items?.map((item) => item));

    const tourss = allItems?.map((item) => ({
      title: item?.status,
      time: `${item?.start_time?.substring(0, 5)}:00 to ${item?.end_time?.substring(0, 5)}:00`,
      category: "Category Title",
      categoryId: item?.category_ids?.[0],
      date: item?.date,
      endTime: `${item?.end_time?.substring(0, 5)}:00`,
      eventId: item?.event_id,
      eventItemId: item?.item_id,
      startTime: `${item?.start_time?.substring(0, 5)}:00`,
      tourId: item?.tour_id,
      customerId: null,
    }));

    setSelectedTours(tourss);
  }, [localBookingsByDate, date]);

  const handleUpdateAttendance = () => {
    if (!bookings?.data?.bookings_by_date || !selectedTours) {
      console.error("Bookings or selectedTours data is missing");
      return;
    }

    const result = [];

    // Helper function to find existing attendance
    const findAttendance = (attendanceId) =>
      result?.find((att) => att.id === attendanceId);

    // Process selected tours
    selectedTours.forEach((selected) => {
      const booking = bookings.data.bookings_by_date[selected.date];

      if (!booking) {
        console.error(`No bookings found for date: ${selected.date}`);
        return;
      }

      // Find the booking that matches the attendance_id
      const attendance = booking?.find((b) =>
        b.items?.some((item) => item.event_item_id === selected.id)
      );

      if (attendance) {
        const existingAttendance = findAttendance(attendance.attendance_id);

        const itemDetails = {
          id: attendance.items?.find((item) => item.event_item_id === selected.id)
            .item_id,
          attendance_id: attendance.attendance_id,
          event_item_id: selected.eventItemId,
          tour_id: selected.tourId,
          category_id: selected.categoryId,
          start_time: selected.startTime,
          end_time: selected.endTime,
          status: "booked",
        };

        if (existingAttendance) {
          existingAttendance.items.push(itemDetails);
        } else {
          result.push({
            id: attendance.attendance_id,
            items: [itemDetails],
          });
        }
      }

      // Handle selected items not booked
      const selectedItemsNotBooked = selectedTours.filter((tour) => {
        return !booking?.some((b) =>
          b.items?.some((item) => item.event_item_id === tour.id)
        );
      });

      selectedItemsNotBooked.forEach((tour) => {
        // Check if the item is already in the result array
        const isAlreadyAdded = result?.some((res) =>
          res.items?.some((item) => item.event_item_id === tour.eventItemId)
        );
        const customer_category_id = Cookies.get("customer_category_id");

        // If the item is not already in the result array, add it
        if (!isAlreadyAdded) {
          result.push({
            customer_category_id: customer_category_id,
            customer_id: selected.customerId,
            event_id: selected.eventId,
            date: selected.date,
            status: "booked",
            items: [
              {
                event_item_id: tour.eventItemId,
                tour_id: tour.tourId,
                category_id: tour.categoryId,
                start_time: tour.startTime,
                end_time: tour.endTime,
                status: "booked",
              },
            ],
          });
        }
      });
    });

    const bookedItemsNotInSelected = bookings.data.bookings_by_date[currentDate]
      .flat()
      .filter(
        (b) =>
          !selectedTours?.some((tour) =>
            b.items?.some((item) => item.event_item_id === tour.id)
          )
      );

    bookedItemsNotInSelected.forEach((b) => {
      const existingAttendance = findAttendance(b.attendance_id);
      if (!existingAttendance) {
        result.push({
          id: b.attendance_id,
          items: [], // No items as this attendance now has no selected items
        });
      }
    });
    setAttendanceData({ attendance: result });

    dispatch(
      updateAttendanceThunk({
        attendanceData: { attendances: result },
        attendanceId: attendanceId,
      })
    ).then((res) => {
      if (res.error) {
        toast.error(res.error.message);
      } else {
        navigate("/personal-page");
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch tours
        const toursResponse = await dispatch(
          fetchToursThunk({ date: currentDate, logout })
        ).unwrap();
        if (
          toursResponse.message ===
          "No tours found for the specified customer categories."
        ) {
          return; // Stop execution
        }
        // Extract service IDs
        const serviceIds = toursResponse.data
          ?.flatMap((tour) => tour?.items) // Flatten all items arrays
          ?.map((item) => item?.service_id);

        // const hasProductIds = "1597,1598";
        const hasProductIds = serviceIds.join(",");

        // Fetch categories
        const categoriesResponse = await dispatch(
          fetchCategoriesThunk({ has_product_ids: hasProductIds })
        ).unwrap();

        // Fetch tour details using hasProductIds
        const toursDetailsResponse = await dispatch(
          fetchToursDetailsThunk({ products_id: hasProductIds })
        ).unwrap();
      } catch (error) {
        console.error("Error during data fetching:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (categories?.data && details?.data) {
      const transformed = categories?.data?.map((category) => {
        const matchingTours = tours?.data?.flatMap((d) => {
          return d.items?.filter((tour) => {
            return tour.category_id?.split(",").includes(`${category.id}`);
          });
        });
        const customerID = Cookies.get("customerId");
        const eventIds = tours?.data?.flatMap((tour) =>
          tour?.items?.map((item) => item.event_id)
        );
        const customer_category_id = Cookies.get("customer_category_id");

        return {
          customer_category_id: customer_category_id,
          id: category.id,
          group: category.title,
          tours: matchingTours?.map((tour) => ({
            id: tour.id,
            tour: details?.data?.find((x) => x.id == tour.service_id)?.name,
            time: `${tour.start_time.slice(0, 5)} to ${tour.end_time.slice(0, 5)}`,
            startTime: tour.start_time,
            endTime: tour.end_time,
            tourId: tour.service_id,
            eventItemId: tour.id,
            eventId: eventIds,
            customerId: customerID,
            date: tour.start.split(" ")[0],
            categoryId: category.id,
            // isSelected: allItemIds.includes(tour.service_id),
          })),
        };
      });

      setTransformedData(transformed);
    }
  }, [categories, details]);
  useEffect(() => {
    if (bookings && transformedData) {
      const bookedToursSet = new Set(); // Track unique event_item_id
      let booking;
      const bookedTours = transformedData?.flatMap((group) =>
        group.tours
          ?.map((tour) => {
            // Find the booking for the tour's date
            if (bookings?.data?.bookings_by_date) {
              booking = bookings.data.bookings_by_date[tour?.date];
            } else return null;
            // if (!booking) return null;

            // Check if the tour matches any booked item
            const matchedBooking = booking?.flatMap((b) =>
              b?.items?.filter(
                (item) =>
                  tour?.id == item?.event_item_id &&
                  item?.category_ids == tour?.categoryId
              )
            );

            if (matchedBooking?.length > 0 && !bookedToursSet?.has(tour?.id)) {
              bookedToursSet?.add(tour?.id); // Add the tour's ID to the Set
              return {
                ...tour,
                selected: true, // Mark the tour as selected
              };
            }

            return null;
          })
          .filter((tour) => tour !== null)
      );

      setSelectedTours(bookedTours);
    }
  }, [bookings, transformedData]);

  let maxToursLength = 0;

  transformedData.forEach((item) => {
    if (item.tours && item.tours.length > maxToursLength) {
      maxToursLength = item.tours.length;
    }
  });
  const { categories: dataCategories, loading: loadingCategories } = useSelector(
    (state) => state.categoriesAfterBooking
  );

  const { loading: loadingDetails } = useSelector(
    (state) => state.toursDetailsAfterBooking
  );

  useEffect(() => {
    // Debounce function to wait until the last loading state update
    const checkLoadingState = debounce(() => {
      const finalLoadingState =
        loadingCategories ||
        loadingDetails ||
        detailsLoading ||
        loading ||
        categoriesLoading;

      setIsLoadingState(finalLoadingState);
    }, 300); // Wait for 300ms (adjust as needed)

    // Check loading state on dependency change
    checkLoadingState();

    // Cleanup debounce
    return () => checkLoadingState.cancel();
  }, [loadingCategories, loadingDetails, detailsLoading, loading, categoriesLoading]);

  return (
    <div className="leap-inset-0 leap-flex leap-items-center leap-justify-center leap-top-0 leap-z-50 leap-bg-black/50">
      <div className="!leap-rounded-3xl leap-w-[100%]  leap-mb-10">
        <div className="leap-bg-transparent leap-rounded-3xl leap-shadow-md leap-p-4 leap-w-[99.5%]   leap-my-[2px]   leap-mx-auto leap-overflow-y-auto">
          <div className="leap-flex leap-justify-start leap-mb-3 leap-mx-auto"></div>
          <div className="leap-h-5 leap-top-2 leap-flex leap-flex-col leap-items-center leap-my-24 ">
            {" "}
            <h1 className="  md:leap-text-4xl leap-font-bold  leap-text-center leap-uppercase leap-text-[#EB3DF7]">
              Change Tour
            </h1>
          </div>
          <div className="leap-text-sm leap-px-2 leap-py-1 ">
            {tours?.message ===
              "No tours found for the specified customer categories." ||
            tours?.data?.length === 0 ? (
              <div className="absolute inset-0 z-10 flex items-center justify-center leap-my-6 bg-black/50">
                <p className=" leap-text-xl leap-text-center leap-font-bold leap-text-[#73FAFD]">
                  No tours found.
                </p>
              </div>
            ) : (
              <>
                {isLoadingState ? (
                  <div className="leap-h-[20rem] leap-my-auto">
                    <Spinner />
                  </div>
                ) : (
                  <div className="">
                    {/* Show Tours on lg and above */}
                    <div className="leap-hidden eh:leap-block">
                      <Tours
                        tourData={transformedData}
                        length={transformedData?.length}
                        bookings={bookings}
                        selectedTours={selectedTours}
                        setSelectedTours={setSelectedTours}
                      />
                    </div>

                    {/* Show ResponsiveTours below lg */}
                    <div className="leap-block eh:leap-hidden">
                      <ResponsiveTours
                        isOpen={true}
                        tourData={transformedData}
                        imageAlt="Tours Image"
                        containerHeight="1150px"
                        length={transformedData?.length}
                        bookings={bookings}
                        selectedTours={selectedTours}
                        setSelectedTours={setSelectedTours}
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div
            className={`leap-my-6 leap-flex leap-justify-center leap-items-center leap-flex-col leap-gap-2 mobile-margin`}
            style={{ marginTop: (maxToursLength - 1) * 185 }}
          >
            {!isLoadingState && (
              <div className="leap-relative">
                {tours?.data?.length !== 0 && (
                  <Button
                    text="change tour"
                    bgColor="#73FAFD"
                    textColor="black"
                    customStyles="leap-uppercase"
                    onClick={handleUpdateAttendance}
                  />
                )}
                {UpdateAttendanceLoading && (
                  <div className="leap-absolute leap-inset-0 leap-flex leap-items-center leap-rounded-2xl leap-bg-black/70 leap-justify-center">
                    <div className="leap-scale-50">
                      <Spinner />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditBooking;
